import type { CsvImportEntity } from '@peles/shared';
import { apiClient } from './client';

export interface CsvImportRequest {
  entity: CsvImportEntity;
  scope?: { eventId?: string };
  rows: Array<Record<string, unknown>>;
}

export interface CsvImportRowError {
  row: number;
  message: string;
}

export interface CsvImportResult {
  created: number;
  skipped: number;
  errors: CsvImportRowError[];
}

export async function runCsvImport({
  entity,
  scope,
  rows,
}: CsvImportRequest): Promise<CsvImportResult> {
  const { data } = await apiClient.post<CsvImportResult>(`/csv-import/${entity}`, {
    scope,
    rows,
  });
  return data;
}
